import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Menu, Segment } from 'semantic-ui-react';

const propTypes = {
};

const defaultProps = {
};

class Tab extends Component {

  constructor(props) {
    super(props);
  }

  render() {

    const { fn, data } = this.props;
    const { auth } = data;
    let width = auth.give && auth.deduct ? 2 : 1;
    let style = width === 1 ? { maxWidth : "50%" } : null;

    return(
      <div>
        <Menu
          className="vendysFullTab"
          fluid
          widths={ width }
          style={style}
          tabular
          attached='top'>
          {
            auth.give
            ? (

              <Menu.Item
                active={ data.tabType === "give" }
                onClick={ (e) => fn.tabMove("give") }>
                <span>지급하기</span>
              </Menu.Item>

            ) : null
          }
          {
            auth.deduct
            ? (

              <Menu.Item
                className={data.tabType === "deduct" ? "deduct" : ""}
                active={ data.tabType === "deduct" }
                onClick={ (e) => fn.tabMove("deduct") }>
                <span>차감하기</span>
              </Menu.Item>

            ) : null
          }
        </Menu>
      </div>
    );
  }
}

Tab.propTypes = propTypes;
Tab.defaultProps = defaultProps;

export default Tab;
